<template>
	<section v-if="show" class="header">
		<div class="row">
			<div class="columns small-9 medium-4 medium-offset-1">
				<div class="text-wrapper">
					<h1 v-text="title"></h1>
				</div>
			</div>
		</div>
		<a href="#" class="page-start-scroll-down scroll-text scroll-indicator-link" @click.prevent="scrollNow" v-text="intro_text">
		</a>
	</section>
</template>

<script>
export default {
	props: ['title', 'intro_text'],
	data() {
		return {
			show: true
		}
	},
	methods: {
		scrollNow() {
			this.$scrollTo('block-1', 700);
		},
		handleScroll() {
			this.show = window.pageYOffset <= (window.innerHeight*2)
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroy() {
		window.removeEventListener('scroll', this.handleScroll);
	}
}
</script>